import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useIdleTimer } from 'react-idle-timer';
import {
  SLASH_DATE_FORMAT,
  DATE_TIME_ONE_FORMAT,
  DATE_TIME_TWO_FORMAT,
  AUTH_ERROR_MSG,
} from '../../common/constants';
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Switch,
  Modal,
  DatePicker,
  Spin,
  Select,
  message,
  Popconfirm,
  Checkbox,
  Tooltip,
} from 'antd';
import { PlusOutlined, SearchOutlined, PlayCircleFilled} from '@ant-design/icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { transferFromFormToResult, convertStorageCode, deleteOriginalItem } from './formattedSubsData';
import {
  useFetchValidationItemData,
  useFetchAddedSubsData,
  useResetConceptData,
  useFetchRecommendedProducts,
  useResetRecommendedProducts,
  useResetSubstituteProducts,
  useValidateSubItem,
} from './redux/hooks';
import { transferFromResultToForm, getUom, checkDropOutRule, getDropOutRuleCreatedInfo, } from './formattedSubsData';
import { CustomLabel, SearchRecommendedProducts, SiteConceptCommonPanel, SubDetail } from './';
import { DROP_OUT_REASON_CODE, REASON_CODE, TOGGLE_NEVER_SUB_TO_SUB_WARNING_MESSAGE, TOGGLE_ONLY_DROP_OUT_TO_SUB_WARNING_MESSAGE, TOGGLE_SUB_TO_NEVER_SUB_WARNING_MESSAGE } from '../../common/manageSubsConstants';
import ManageOutsOperateModal from './ManageOutsOperateModal';
import { datadogRum } from '@datadog/browser-rum';
import _ from 'lodash';
import { CustomLabelWithValue } from './CustomLabel';
export default function OgmSubsOperateModal(props) {
  const {
    userName,
    userId,
    expandedItemEntity,
    substitutionsHeaderEntity,
    conceptData,
    fetchValidationItemDataPending,
    fetchAddedSubsDataPending,
    fetchValidationCustomerDataPending,
    validateSubItemPending,
    recommendedProducts,
    substituteProducts,
  } = useSelector(state => ({
    userName: state.home.auth.user.userName,
    userId: state.home.auth.user.userId,
    expandedItemEntity: state.manageSubs.expandedItemEntity,
    substitutionsHeaderEntity: state.manageSubs.substitutionsHeaderEntity,
    conceptData: state.manageSubs.conceptData,
    fetchValidationItemDataPending: state.manageSubs.fetchValidationItemDataPending,
    fetchAddedSubsDataPending: state.manageSubs.fetchAddedSubsDataPending,
    fetchValidationCustomerDataPending: state.manageSubs.fetchValidationCustomerDataPending,
    validateSubItemPending: state.manageSubs.validateSubItemPending,
    recommendedProducts: state.manageSubs.recommendedProducts,
    substituteProducts: state.manageSubs.substituteProducts,
  }));
  const {
    title,
    isModalVisible,
    footer,
    width,
    siteData,
    initValueData,
    onToggleModal,
    cancelText,
    okText,
    onOk,
    loading,
    onDelete,
    idle,
    // onChangeTitle
  } = props;

  const onIdle=()=>{
    idle()
    onModalClose()
  }
  
  const formattedRecord = initValueData && transferFromResultToForm(initValueData);
  const { fetchValidationItemData } = useFetchValidationItemData();
  // const { fetchValidationItemDataError } = useFetchValidationItemData();
  const { validateSubItem } = useValidateSubItem();
  const { fetchAddedSubsData } = useFetchAddedSubsData();
  const { resetConceptData } = useResetConceptData();
  const [neverSubFlag, setNeverSubFlag] = useState(formattedRecord && !formattedRecord.ruleType);
  const [selectConceptKey, setSelectConceptKey] = useState('');
  const { fetchRecommendedProducts } = useFetchRecommendedProducts();
  const { resetRecommendedProducts } = useResetRecommendedProducts();
  const { resetSubstituteProducts } = useResetSubstituteProducts();
  const [isExist, setIsExist] = useState(false)
  const [originalUom, setOriginalUom] = useState('')
  const [isSelectSubModalVisible, setSelectSubModalVisible] = useState(false);
  const [baseData, setBaseData] = useState(null);
  const [isSaveBtnDisabled, setSaveBtnDisabled] = useState(false)
  const [form] = Form.useForm();
  const [reloadData,setReloadData] = useState(null);
  const [isExistDropOutRule, setIsExistDropOutRule] = useState(initValueData && checkDropOutRule(initValueData))
  const [wasDropOutRule, setWasDropOutRule] = useState(initValueData && checkDropOutRule(initValueData))
  const [expandedLength] = useState(initValueData!==undefined && initValueData.expandedItems!==undefined?initValueData.expandedItems:null)
  const [idleTime]= useState(title && title.toLowerCase() === 'edit sub rule'? 1000*60*5: 1000*60*60);
  const idleTimer = useIdleTimer({ onIdle,timeout: idleTime, })
  //  useEffect(() => {
  //   if (fetchValidationItemDataError) {
  //     message.error(fetchValidationItemDataError);
  //   }
  // }, [fetchValidationItemDataError]); //COT-10152
  const initCreatedTimestampFields = {
    createdByName: userName,
    createdById: userId,
    createTimestamp: moment().format(DATE_TIME_TWO_FORMAT),
  };
  const initModifiedTimestampFields = {
    modifiedByName: userName,
    modifiedById: userId,
    modifiedTimestamp: moment().format(DATE_TIME_TWO_FORMAT),
  };
  const initCreatedValues = {
    ruleType: true,
    // expandedSubItems: [{ ...expandedItemEntity, ...initCreatedTimestampFields, subPriority: '1', subRatio: '1.00', }],
    expandedSubItems: [],
    expandedNoSubItems: [],
    ...initCreatedTimestampFields,
    ...initModifiedTimestampFields,
  };
  const dropOutRuleCreateInfo = {
    createTimestamp: null,
    createdById: null,
    createdByName: null,
  }
  if(initValueData) {
    getDropOutRuleCreatedInfo(initValueData, dropOutRuleCreateInfo)
  }
  const initialValues = formattedRecord || initCreatedValues;

  const formatSubRatioForUi = value => {
    if (value === null || value === undefined || String(value).trim() === '') return '1.00';
    const n = Number(value);
    return Number.isFinite(n) ? n.toFixed(2) : '1.00';
  };

  // const dropoutCheck=  title==='Edit sub rule'?(((initValueData.substituteItem==='' && ( initValueData.ruleType===CONST_SUB_RULE_TYPE || initValueData.ruleType===CONST_NONE_SUB_RULE_TYPE) )|| initValueData.ruleType==='dropout'))? true : false:null;
  //COT-5289
  // const dropoutCheck=  title==='Edit sub rule'?(initValueData && initValueData.ruleType==='dropout')? true : false:null;
  const dropoutCheck = null;
  const handleItemPressEnter = (e) => {
    e.target.blur()
  };
   const parseDropoutReasonDescription = (reasonCode)=>{
      return DROP_OUT_REASON_CODE.filter(item=>item.key === reasonCode)[0].label;
    }
  const handleDropoutReasonChg = (value, label, key, listFieldName)=>{
    let objFormValues = form.getFieldsValue();

    objFormValues[listFieldName][key] = {
      ...objFormValues[listFieldName][key],
      ...initModifiedTimestampFields,
      [label]: value,
    };
    //parse reasonDescription field and save to database as this field is not display 
      objFormValues[listFieldName][key] = {
        ...objFormValues[listFieldName][key],
        'reasonDescription':parseDropoutReasonDescription(value)
    }
    form.setFieldsValue(objFormValues);
  }
  const handleItemChange = (value, label, key, listFieldName) => {
    let objFormValues = form.getFieldsValue();
    let objCurr = {};

    switch (label) {
      case 'site':
        const siteObj = siteData.find(item => item.opcoNo === value);
        objCurr = {
          [label]: value,
          siteDesc: siteObj ? siteObj.opcoName : '',
          nationalId: '',
          nationalName: '',
          customerId: '',
          customerName: '',
        };
        resetConceptData()
        form.setFieldsValue({ ...objFormValues, ...objCurr });
        setDragInitialValues({...dragInitialValues,site:value});
        return;
      case 'nationalId':
        if ((value === undefined || value.length < 4) && conceptData) {
          resetConceptData();
        }
        objCurr = {
          [label]: value,
          nationalName: '',
          customerId: '',
          customerName: '',
        };
        form.setFieldsValue({ ...objFormValues, ...objCurr });
        if(validateNumericRegExp(value)) setDragInitialValues({...dragInitialValues,customerNumber:value});
        else setDragInitialValues({...dragInitialValues,nationalId:value}); 
        return;
      case 'originalItem':
        objCurr = {
          [label]: value,
          originalBrand: '',
          originalItemDescription: '',
          originalPack: '',
          originalSize: '',
          originalStorageCode: '',
          originalUom: '',
        };
        form.setFieldsValue({ ...objFormValues, ...objCurr });
        setDragInitialValues({...dragInitialValues,originalItem:value});
        return;
      case 'selectedUom':
        objCurr = {
          [label]: value,
        };
        form.setFieldsValue({ ...objFormValues, ...objCurr });
        const { site, siteDesc, nationalId, nationalName, customerNumber, customerName, originalItem, } = objFormValues;
        const formData = formattedSubmitFormData({...substitutionsHeaderEntity, 'originalUom': value, site, siteDesc, nationalId, nationalName, customerNumber, customerName, originalItem, });
        fetchAddedSubsData(formData).then(data => {
          if (typeof data === 'object') {
            setIsExist(true)
            getDropOutRuleCreatedInfo(data, dropOutRuleCreateInfo)
            if(checkDropOutRule(data)) {
              setIsExistDropOutRule(true)
            } else {
              setIsExistDropOutRule(false)
            }
            //COT-4634,store reload data
            setReloadData(data);
            const reloadFormValues = transferFromResultToForm(data);
            reloadFormValues.selectedUom = reloadFormValues.originalUom
            reloadFormValues.originalUom = objFormValues.originalUom
            form.setFieldsValue(reloadFormValues);
            setNeverSubFlag(!reloadFormValues.ruleType);
            if(reloadFormValues.ruleType && (!reloadFormValues.expandedSubItems || reloadFormValues.expandedSubItems.length === 0) && (!reloadFormValues.expandedNoSubItems || reloadFormValues.expandedNoSubItems.length === 0)) {
              setSaveBtnDisabled(true)
            } else {
              setSaveBtnDisabled(false)
            }
          } else if(data === '') {
            setIsExist(false)
            setIsExistDropOutRule(false)
            dropOutRuleCreateInfo.createTimestamp = null
            dropOutRuleCreateInfo.createdById = null
            dropOutRuleCreateInfo.createdByName = null
            form.setFieldsValue({ ...objFormValues, ...initCreatedValues });
            const neverSubFlag = initCreatedValues.ruleType === false;
            setNeverSubFlag(neverSubFlag);
             const values={ ...objFormValues, ...initCreatedValues }
            if(values.ruleType && (!values.expandedSubItems || values.expandedSubItems.length === 0) && (!values.expandedNoSubItems || values.expandedNoSubItems.length === 0)) {
              setSaveBtnDisabled(true)
            } else {
              setSaveBtnDisabled(false)
            }
            //setSaveBtnDisabled(false)
          } else {
            message.error(`There is an error. Please refresh page or contact administrator.`);
          }
        });
        /*const { expandedSubItems, expandedNoSubItems } = objFormValues
        const errorList = []
        expandedSubItems.forEach((item, index) => {
          if(item.substituteUom) {
            if(item.substituteUom != "CS-EA" && item.substituteUom != value) {
              item.isInvalidUOM = true
              errorList.push({
                "name": ["expandedSubItems", index, "substituteItem"],
                "errors": ['UOM mismatch!'],
              })
            } else {
              item.isInvalidUOM = false
              errorList.push({
                "name": ["expandedSubItems", index, "substituteItem"],
                "errors": null,
              })
            }
          }
        })
        expandedNoSubItems.forEach((item, index) => {
          if(item.substituteUom) {
            if(item.substituteUom != "CS-EA" && item.substituteUom != value) {
              item.isInvalidUOM = true
              errorList.push({
                "name": ["expandedNoSubItems", index, "substituteItem"],
                "errors": ['UOM mismatch!'],
              })
            } else {
              item.isInvalidUOM = false
              errorList.push({
                "name": ["expandedNoSubItems", index, "substituteItem"],
                "errors": null,
              })
            }
          }
        })
        form.setFields(errorList)*/
        setDragInitialValues({...dragInitialValues,originalItemUom:value});
        return;
      case 'subPriority':
      case 'subRatio': 
      // const val = parseFloat(value);
      // const reg = new RegExp('^(((?!0+(?:\.0+)?$)(([1-9]{1}\\d{0,2})|(0{1}))(\\.\\d{1,2}))|([0-9]{1}\\d{0,2}))?$', 'g');
      // if(!reg.test(val)) {
      //   message.warning('Invalid input! The sub ratio should be a value in the range 0.01 to 999.99!')
      //   return
      // }
      case 'endDate':
        //COT-5289,when change endDate for never sub and drop out rule,should store modifiedByName,modifiedById,modifiedTimestamp
        if(neverSubFlag || dropoutCheck){
          form.setFieldsValue({...objFormValues,...initModifiedTimestampFields});
        }else{
          objFormValues[listFieldName][key] = {
            ...objFormValues[listFieldName][key],
            ...initModifiedTimestampFields,
            [label]: value,
          };
          form.setFieldsValue(objFormValues);
        }
        return;
      case 'reasonCode':
        objFormValues[listFieldName][key] = {
          ...objFormValues[listFieldName][key],
          ...initModifiedTimestampFields,
          [label]: value,
        };
        //parse reasonDescription field and save to database as this field is not display 
        if(label === 'reasonCode'){
          objFormValues[listFieldName][key] = {
            ...objFormValues[listFieldName][key],
            'reasonDescription':parseReasonDescription(value)
          }
        }
        form.setFieldsValue(objFormValues);
        return;
      case 'substituteItem':
        objCurr = {
          [label]: value,
          substituteBrand: '',
          substituteItemDescription: '',
          substitutePack: '',
          substituteSize: '',
          substituteStorageCode: '',
          substituteUom: '',
        };
        objFormValues[listFieldName][key] = {
          ...objFormValues[listFieldName][key],
          ...objCurr,
          ...initModifiedTimestampFields,
          ...initCreatedTimestampFields,
        };
        form.setFieldsValue(objFormValues);
        return;
      case 'customerApprovalFlag':
        objFormValues[listFieldName][key] = {
          ...objFormValues[listFieldName][key],
          ...initModifiedTimestampFields,
          [label]: value,
      };
        form.setFieldsValue(objFormValues);
        return;
      default:
        return;
    }
  };
  const parseReasonDescription = (reasonCode)=>{
    return REASON_CODE.filter(item=>item.key === reasonCode)[0].label;
  }
  const validDuplicatedItem = (value, objFormValues) => {
    const allSubItemsData =
      objFormValues.expandedSubItems &&
      objFormValues.expandedSubItems.concat(objFormValues.expandedNoSubItems);
    if(allSubItemsData){
      const dupIndex = allSubItemsData && allSubItemsData.filter(
        item => item.substituteItem && item.substituteItem.trim().toString() === value.trim().toString(),//defect:COT-5561,trim extra space for original item and substituteItem
      );
      return dupIndex;
    }else{
      return -1;
    }
  }
  
  //moment.js bug? I am not sure...
  let currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let date = currentDate.getDate();
  if(month < 10) month = '0' + month;
  if(date < 10) date = '0' + date;
  //Create moment by year, month and day, instead of directly moment()
  let tempMoment = moment(`${year}${month}${date}`, 'YYYYMMDD')
  const startDate = tempMoment.subtract(0, 'day')
  const disablePastDt = current => {
    return current.isBefore(startDate);
  };
  const funcValidOriginalItem = (rule, value, callback) => {
    const timing = Date.now();
    if (value && value.length) {
      const objFormValues = form.getFieldsValue();
      const dupIndex = validDuplicatedItem(value, objFormValues);
      if (!validateNumericRegExp(value)) { //Item number should be always 7 digits,it cannot be less or more
        callback('Invalid Original Item!');
      } else if (value.length !== 7) {
        callback('Original Item should be 7 digits!');
      } else if (dupIndex.length > 0) {
        callback('Duplicated Original Item!');
      } else {
        const itemValidformData = { opcoId: objFormValues.site, productId: value };
        fetchValidationItemData(itemValidformData).then(
          productInfo => {
            //COT-5366 show original item kosher
            // form.setFieldsValue({ ...objFormValues, originalItemKosher: productInfo.kosher })
            const currFields = {
              originalItem: value,
              originalBrand: productInfo.brandId,
              originalItemDescription: productInfo.name,
              originalPack: productInfo.pack,
              originalSize: productInfo.size,
              originalStorageCode: productInfo.storageCode,
              originalUom: getUom({shipSplitsOnly:productInfo.shipSplitOnly, minimumSplit:productInfo.minimumSplit}),
              selectedUom: '',
              originalItemKosher: productInfo.kosher,
            };
            if(currFields.originalUom !== 'CS-EA') {
              currFields.selectedUom = currFields.originalUom
            } else {
              currFields.selectedUom = objFormValues.selectedUom || 'CS'
            }
            setOriginalUom(currFields.originalUom)
            setDragInitialValues({...dragInitialValues,originalItemUom:currFields.originalUom});//COT-9714, pass uom to manageOutsAddSub component for additional search
            const { site, siteDesc, nationalId, nationalName, customerNumber, customerName, originalItem, } = objFormValues;
            const formData = formattedSubmitFormData({...substitutionsHeaderEntity, 'originalUom': currFields.selectedUom, site, siteDesc, nationalId, nationalName, customerNumber, customerName, originalItem, });
            fetchAddedSubsData(formData).then(data => {
              if (typeof data === 'object') {
                setIsExist(true)
                getDropOutRuleCreatedInfo(data, dropOutRuleCreateInfo)
                if(checkDropOutRule(data)) {
                  setIsExistDropOutRule(true)
                } else {
                  setIsExistDropOutRule(false)
                }
                //COT-4634,store reload data
                setReloadData(data);
                const reloadFormValues = transferFromResultToForm(data);
                reloadFormValues.selectedUom = reloadFormValues.originalUom
                reloadFormValues.originalUom = currFields.originalUom
                reloadFormValues.originalItemKosher = currFields.originalItemKosher
                form.setFieldsValue(reloadFormValues);
                // onChangeTitle(data);
                setNeverSubFlag(!reloadFormValues.ruleType);
                // COT-5289,when reload drop out rule data in add screen,should hidden sub/never sub toggle,and show effective date field
                // if (reloadFormValues.ruleType === CONST_DROP_OUT_RULE_TYPE) {
                //   setNeverSubFlag(true);
                //   setDropoutCheck(true);
                // } else {
                //   setNeverSubFlag(!reloadFormValues.ruleType);
                //   setDropoutCheck(false);
                // }
                 if(reloadFormValues.ruleType && (!reloadFormValues.expandedSubItems || reloadFormValues.expandedSubItems.length === 0) && (!reloadFormValues.expandedNoSubItems || reloadFormValues.expandedNoSubItems.length === 0)) {
                  setSaveBtnDisabled(true)
                } else {
                  setSaveBtnDisabled(false)
                }
                callback();
              } else if(data === '') {
                setIsExist(false)
                setIsExistDropOutRule(false)
                dropOutRuleCreateInfo.createTimestamp = null
                dropOutRuleCreateInfo.createdById = null
                dropOutRuleCreateInfo.createdByName = null
                form.setFieldsValue({ ...objFormValues, ...currFields, ...initCreatedValues });
                const values={ ...objFormValues, ...currFields, ...initCreatedValues }
                const neverSubFlag = initCreatedValues.ruleType === false;
                setNeverSubFlag(neverSubFlag);
                if(values.ruleType && (!values.expandedSubItems || values.expandedSubItems.length === 0) && (!values.expandedNoSubItems || values.expandedNoSubItems.length === 0)) {
                  setSaveBtnDisabled(true)
                } else {
                  setSaveBtnDisabled(false)
                }
                //setSaveBtnDisabled(false)
                callback();
              } else {
                message.error(`There is an error. Please refresh page or contact administrator.`);
                callback()
              }
            });
          },
          err => {
            if (err !== AUTH_ERROR_MSG) {
              //callback('Invalid Original Item!');  /*COT-10361*/
              if (err && typeof err === 'object' && err.result === 'Failed' && err.errorMessage) {
                message.error(err.errorMessage); // This will show: "Original item is remote stock item"
              }
              else if (err !== AUTH_ERROR_MSG) {
                callback('Invalid Original Item!');
              }
            }
          },
        );
      }
    } else {
      callback();
    }
    datadogRum.onReady(function(){
      datadogRum.addTiming(`Validate Original Item`,timing);
    });
  };
  const handleOriginalItemValidator = (rule, value, callback) => {
    form.validateFields(['site', 'nationalId']).then(() => {
        funcValidOriginalItem(rule, value, callback);
    }).catch(errorInfo => {
      //ANTD 4.x BUG ISSUE: IT WILL ALWAYS GOTO CATCH EVEN NO ERRORS
      if (errorInfo.errorFields.length > 0) {
        callback();
      } else {
        funcValidOriginalItem(rule, value, callback);
      }
    });
  };
  const handleSubItemValidator = (rule, value, callback, label, key = 0) => {
    const timing = Date.now();
    form.validateFields(['site']).then(() => {
      if (value && value.length) {
        const objFormValues = form.getFieldsValue();
        if(!objFormValues.originalUom) {
          let errorList = []
          errorList.push({
            "name": ["originalItem"],
            "errors": ['Invalid Original Item!'],
          })
          form.setFields(errorList)
          return
        }
        const dupIndex = validDuplicatedItem(value, objFormValues);
        if (dupIndex.length > 1 || (objFormValues.originalItem && value.toString() === objFormValues.originalItem.toString())) {
          callback('Duplicated Sub/Not-Suit-Sub Item!');
        } else if (!validateNumericRegExp(value)) { //Item number should be always 7 digits,it cannot be less or more
          callback('Invalid Sub/Not-Suit-Sub Item!');
        } else if (value.length !== 7) {
          callback('Sub Item should be 7 digits!');
        } else {
          validateSubItem({
            "customerNumber": validateNumericRegExp(objFormValues.nationalId) ? objFormValues.nationalId : '',
            "item": value,
            "nationalId": validateNumericRegExp(objFormValues.nationalId) ? '' : objFormValues.nationalId,
            "site": objFormValues.site,
          }).then(res => {
            if(res && res.result && res.result === "Success") {
              const { data } = res
              const uom = getUom({shipSplitsOnly:data.shipSplitOnly, minimumSplit:data.minimumSplit});
              const selectedUom = objFormValues.selectedUom || objFormValues.originalUom
              const isInvalidUOM = uom !== 'CS-EA' && uom !== selectedUom
              const currFields = {
                substituteItem: value,
                substituteBrand: data.brandId,
                substituteItemDescription: data.name,
                substitutePack: data.pack,
                substituteSize: data.size,
                substituteStorageCode: data.storageCode,
                substituteUom: uom,
                isInvalidUOM,
              };
              objFormValues[label][key] = {
                ...objFormValues[label][key],
                ...currFields,
                ...initModifiedTimestampFields,
              }
              form.setFieldsValue(objFormValues);
              if(isInvalidUOM) {
                callback('UOM mismatch!');
              } else {
                callback();
              }
            }else if(res && res.result && res.result === "Failed") {
              const { errorMessage } = res
              callback(errorMessage)
            }else {
              callback('Invalid Sub/Not-Suit-Sub Item!');
            }
          }, err => {
            if(err === AUTH_ERROR_MSG) {
              callback()
            }else {
              callback('Invalid Sub/Not-Suit-Sub Item!');
            }
          })
        }
      } else {
        callback();
      }
    }).catch(errorInfo => {
      callback();
    });
    datadogRum.onReady(function(){
      datadogRum.addTiming(`Validate Sub/Not-Suit-Sub Item`,timing);
    });
  };
  //To validate search text is only numeric or not
  const validateNumericRegExp = value => {
    const pattNumeric = new RegExp('^[0-9]*$', 'g');
    const isNumeric = pattNumeric.test(value);
    return isNumeric;
  };
  const onToggleSubNeverRuleType = checked => {
    const objForm = form.getFieldsValue();
    const { expandedSubItems, expandedNoSubItems, ruleType } = objForm;
    setIsExistDropOutRule(false)
    if (checked) {
      let items = (objForm.expandedSubItems || []).slice(0, 4);
      while (items.length < 4) {
        items.push({});
      }
      items = items.map((item, idx) => ({
        ...item,
        subPriority: `${idx + 1}`,
        //subRatio: item.subRatio === undefined || item.subRatio === null || item.subRatio === "" ? '1.00' : item.subRatio,
        subRatio: formatSubRatioForUi(item.subRatio),
      }));
      const objNewSubFields = {
        // expandedSubItems: [{ ...expandedItemEntity, ...initCreatedTimestampFields, subPriority: '1', subRatio: '1.00' },],
        //expandedSubItems: [],
        expandedSubItems:items,
        expandedNoSubItems: [],
        ...initModifiedTimestampFields,
      };
      form.setFieldsValue({ ...objForm, ...objNewSubFields });
    } else {
      delete objForm.expandedSubItems;
      delete objForm.expandedNoSubItems;
      //COT-9085:UI - BOS2.0 -INC000004991046- When creating a drop out rule, SUS did not delete expired never sub rules-remove default endDate if switch other rule types to neversub and original sub is not never sub
      let endDate = null;
      if(title && title?.toLowerCase() === 'edit sub rule' && initValueData && initValueData?.ruleType === 'neversub' && !_.isEmpty(initValueData?.endDate)){
        endDate = moment(initValueData.endDate);
      }else if(title && title?.toLowerCase() === 'add sub rule' && reloadData && reloadData?.ruleType === 'neversub' && !_.isEmpty(reloadData?.endDate)){
        endDate = moment(reloadData.endDate);
      }
      form.setFieldsValue({ ...objForm, ruleType: false, ...initModifiedTimestampFields, ...initCreatedTimestampFields,endDate:endDate });
      //form.setFieldsValue({ ...objForm, ...initModifiedTimestampFields, ...initCreatedTimestampFields,endDate:endDate });
    }
    if(ruleType && (!expandedSubItems || expandedSubItems.length === 0) && (!expandedNoSubItems || expandedNoSubItems.length === 0)) {
      setSaveBtnDisabled(true)
    } else {
      setSaveBtnDisabled(false)
    }
    setNeverSubFlag(!checked);
    //setSaveBtnDisabled(false)
    //defect:COT-4634,Warning message is not being displayed when a new sub/no-sub rule is created when a never sub rule is existing for the site id - concept/ship to - original item combination
    let newObjForm = form.getFieldsValue();
    if(!dropoutCheck && title && title.toLowerCase() === 'edit sub rule'){
      checkSwitchRuleType(initValueData,newObjForm,true);
    }else if(title && title.toLowerCase() === 'add sub rule'){
      checkSwitchRuleType(reloadData,newObjForm,true);
    }
  };
  
  const onToggleSubNonRuleType = (checked, key = 0) => {
  //sub/none-sub item row lowbound start from 0.
  const objForm = form.getFieldsValue();
  let objSubInst = objForm.expandedSubItems;
  let objNonSubInst = objForm.expandedNoSubItems;
  const ruleType = checked;

  // Count only filled sub rows (with substituteItem)
  const filledSubCount = objSubInst.filter(
    item => item && item.substituteItem && item.substituteItem.trim() !== ''
  ).length;

  if (filledSubCount === 4 && ruleType) {
    //if sub item has 4 filled items, can't switch from no-sub to sub
    objNonSubInst[key].ruleType = !ruleType;
  } else if (ruleType) {
    //if change from no-sub to sub, remove no-sub item row, add it to first empty sub item row or append if none
    const objRemoved = objNonSubInst.splice(key, 1)[0];
    // Find first empty sub row
    const emptyIndex = objSubInst.findIndex(
      item => !item.substituteItem || item.substituteItem.trim() === ''
    );
    const {
      substituteItem,
      substituteItemDescription,
      substituteBrand,
      substitutePack,
      substituteSize,
      substituteStorageCode,
      substituteUom,
      endDate,
      customerApprovalFlag,
    } = objRemoved;
    const objFormattoSubItem = {
      ruleType,
      substituteItem,
      substituteItemDescription,
      substituteBrand,
      substitutePack,
      substituteSize,
      substituteStorageCode,
      substituteUom,
      endDate,
      customerApprovalFlag,
    };
    if (emptyIndex !== -1) {
      // Place in first empty row
      objSubInst[emptyIndex] = {
        ...objSubInst[emptyIndex],
        ...expandedItemEntity,
        ...objFormattoSubItem,
        subPriority: `${emptyIndex + 1}`,
       // subRatio: objSubInst[emptyIndex].subRatio || '1.00',
       subRatio: formatSubRatioForUi(objSubInst[emptyIndex].subRatio),
        ...initModifiedTimestampFields,
        ...initCreatedTimestampFields,
      };
    } else {
      // No empty row, append as new row
      objSubInst.push({
        ...expandedItemEntity,
        ...objFormattoSubItem,
        subPriority: `${objSubInst.length + 1}`,
        subRatio: '1.00',
        ...initModifiedTimestampFields,
        ...initCreatedTimestampFields,
      });
    }
  } else {
    //if change from sub to no-sub, remove only substituteItem fields from sub row, add them to no-sub, and keep the sub row empty
    let objRemoved = objSubInst[key];
    if (objRemoved && objRemoved.substituteItem) {
      const {
        substituteItem,
        substituteItemDescription,
        substituteBrand,
        substitutePack,
        substituteSize,
        substituteStorageCode,
        substituteUom,
        endDate,
        customerApprovalFlag,
      } = objRemoved;
      const objFormattoNonSubItem = {
        ruleType,
        substituteItem,
        substituteItemDescription,
        substituteBrand,
        substitutePack,
        substituteSize,
        substituteStorageCode,
        substituteUom,
        endDate,
        reasonCode: 'R30',
        reasonDescription: 'CUSTOMER NOT SATISFIED',
        customerApprovalFlag,
      };//common fields between sub and no-sub
      // Add to no-sub table
      objNonSubInst.push({
        ...expandedItemEntity,
        ...objFormattoNonSubItem,
        ...initModifiedTimestampFields,
        ...initCreatedTimestampFields,
      });

      // Clear only the substitute fields in the sub row, keep subPriority and subRatio
      objSubInst[key] = {
        ...objSubInst[key],
        substituteItem: '',
        substituteItemDescription: '',
        substituteBrand: '',
        substitutePack: '',
        substituteSize: '',
        substituteStorageCode: '',
        substituteUom: '',
        endDate: null,
        customerApprovalFlag: null,
        ruleType: true, // keep as sub
        // keep subPriority and subRatio as is
      };
    }
  }
  //to update sub item priority value when switch toggle
  objSubInst.forEach((item, index) => {
    item.subPriority = `${index + 1}`;
    item.modifiedByName = userName;
    item.modifiedById = userId;
    item.modifiedTimestamp = moment().format(DATE_TIME_TWO_FORMAT);
  });
  const newObjForm = {
    ...objForm,
    expandedSubItems: objSubInst,
    expandedNoSubItems: objNonSubInst,
  };
  form.setFieldsValue(newObjForm);
};
  const handleAddDropout = (add,ruleType, fields, errors)=>{
      let priorityObj = { subPriority: null };
      let subRatio = null;
      let reasonCode = null;
      let reasonDescription = null;//cot-9907, set reasonCode and reasonDescription to null when create dropout rule from sub repository
      setSaveBtnDisabled(false)
      add({ ...expandedItemEntity, ruleType, ...initCreatedTimestampFields, ...priorityObj, subRatio, reasonCode, reasonDescription,...initModifiedTimestampFields });
    }
  const handleOperatedSubItems = (add, ruleType, fields, errors) => {
    let priorityObj = { subPriority: null };
    let subRatio = null;
    let reasonCode = null
    let reasonDescription = null
    if (ruleType) {
      priorityObj = { subPriority: `${fields.length + 1}` };
      subRatio = '1.00';
    } else {
      reasonCode = 'R30';
      reasonDescription = 'CUSTOMER NOT SATISFIED'
    }
    setSaveBtnDisabled(false)
    add({ ...expandedItemEntity, ruleType, ...initCreatedTimestampFields, ...priorityObj, subRatio, reasonCode, reasonDescription, });
  };
  const formattedSubmitFormData = values => {
    const customerObj = {
      nationalId: validateNumericRegExp(values.nationalId) ? '' : values.nationalId,
      nationalName: validateNumericRegExp(values.nationalId) ? '' : values.nationalName,
      customerNumber: validateNumericRegExp(values.nationalId) ? values.nationalId : '',
      customerName: validateNumericRegExp(values.nationalId) ? values.nationalName : '',
      originalUom: values.selectedUom || values.originalUom,
      ruleType: initValueData?initValueData.ruleType:'',
    };
    const extraInfo = {
      isExistDropOutRule,
      modifiedByName: userName,
      modifiedById: userId,
      modifiedTimestamp: moment().format(DATE_TIME_TWO_FORMAT),
      createdByName: dropOutRuleCreateInfo.createdByName,
      createdById: dropOutRuleCreateInfo.createdById,
      createTimestamp: dropOutRuleCreateInfo.createTimestamp,
    }
    const formData = transferFromFormToResult({ ...values, ...customerObj }, extraInfo);
   
    //defect:COT-5561,trim the extra space for originalItem
    formData.originalItem = formData.originalItem.trim();
    
    
    return formData;
  };
  const checkUom = (formData) => {
    let { selectedUom, expandedSubItems, expandedNoSubItems } = formData
    if(!selectedUom) {
      selectedUom = formData.originalUom
    }
    let subItemsIsInvalid = false
    let noSubItemsIsInvalid = false

    // Only check rows that have a substituteItem filled and substituteUom is not undefined/null/empty
    if (expandedSubItems && expandedSubItems.length > 0) {
      subItemsIsInvalid = expandedSubItems
        .filter(item =>
          item.substituteItem &&
          item.substituteItem.trim() !== '' &&
          item.substituteUom !== undefined &&
          item.substituteUom !== null &&
          item.substituteUom !== ''
        )
        .some(item => item.substituteUom !== 'CS-EA' && item.substituteUom !== selectedUom);
    }
    if(!expandedNoSubItems) {
      noSubItemsIsInvalid = false
    } else {
      noSubItemsIsInvalid =expandedNoSubItems.filter((item)=>item.ruleType !== 'dropout').some(item => {
        return item.substituteUom != 'CS-EA' && item.substituteUom != selectedUom
      })
    }
    return !subItemsIsInvalid && !noSubItemsIsInvalid
  };
  const onFinish = () => {
    let formData = form.getFieldsValue();
    const { expandedSubItems, expandedNoSubItems } = formData
    if (expandedSubItems) {
      // Filter out empty rows
      const filledRows = expandedSubItems.filter(
        val => val && val.substituteItem && val.substituteItem.trim() !== ''
      );
      // Reassign subPriority and ensure ruleType/subRatio for each filled row
      filledRows.forEach((val, idx) => {
        val.subPriority = `${idx + 1}`;
        if (!val.ruleType) val.ruleType = 'sub';
        if (val.subRatio === "" || val.subRatio === undefined || val.subRatio === null) {
          val.subRatio='1.00';
        }
      });
      // Only keep filled rows for submission
      formData.expandedSubItems = filledRows;
    }
    
    let validator = true;
    const allFieldsList = form.getFieldsError();
    const allErrorList = allFieldsList.filter(item => {
      return item.errors.length > 0;  //item has error msg
    });
    form.validateFields(['nationalId']).catch(errorInfo => {
      if (errorInfo.errorFields.length > 0) {
        validator = false;
      }
    }).finally(() => {
      const errorList = []
      if(!formData.originalItem) {
        errorList.push({
          "name": ["originalItem"],
          "errors": ['Please input Original Item!'],
        })
      }
      // Only validate sub rows that have a value for substituteItem or any other field
      expandedSubItems && expandedSubItems.forEach((item, index) => {
        const isRowEmpty =
          !item.substituteItem &&
          !item.substituteBrand &&
          !item.substituteItemDescription &&
          !item.substitutePack &&
          !item.substituteSize &&
          !item.substituteStorageCode &&
          !item.substituteUom &&
          !item.endDate &&
          !item.customerApprovalFlag;
        if (!isRowEmpty && (!item.substituteItem || item.substituteItem.trim() === '')) {
          errorList.push({
            "name": ["expandedSubItems", index, "substituteItem"],
            "errors": ['Please input Sub Item!'],
          });
        }
        // Fix: Also ensure subRatio is always a string for filled rows
        if (!isRowEmpty && (item.subRatio === undefined || item.subRatio === null)) {
          item.subRatio = '1.00';
        }
      })
      expandedNoSubItems && expandedNoSubItems.forEach((item, index) => {
        if((item.substituteItem == null || item.substituteItem == undefined || item.substituteItem.trim() == '') && item.ruleType !== 'dropout') {
          errorList.push({
            "name": ["expandedNoSubItems", index, "substituteItem"],
            "errors": ['Please input Not-Suit-Sub Item!'],
          })
        }
        // Fix: Also ensure subRatio is always a string for filled rows in NoSubItems
        if (item.substituteItem && (item.subRatio === undefined || item.subRatio === null)) {
          item.subRatio = '1.00';
        }
      })
      if(errorList.length) {
        form.setFields(errorList)
        return
      }

      if (validator && formData && allErrorList.length === 0) {
        if( !(dropoutCheck!==null && dropoutCheck) && !checkUom(formData)) {
          message.error('UOM mismatch, please check!')
        } else {
          // Only filter out empty sub rows from expandedSubItems before submit
          formData.expandedSubItems = (formData.expandedSubItems || []).filter(item =>
            item.substituteItem && item.substituteItem.trim() !== ''
          );
          // Do NOT filter expandedNoSubItems

          formData = formattedSubmitFormData(formData);
          
          formData.callFrom = 'ogmSubs';
          //defect:COT-4634,Warning message is not being displayed when a new sub/no-sub rule is created when a never sub rule is existing for the site id - concept/ship to - original item combination
          if(!dropoutCheck && title && title.toLowerCase() === 'edit sub rule'){
            checkSwitchRuleType(initValueData,formData,false);
          }else if(title && title.toLowerCase() === 'add sub rule'){
            checkSwitchRuleType(reloadData,formData,false);
          }
          resetConceptData();
          //COT-9112:BOS 2.0 -UI- Audit trail for manage subs, add modifiedByName,modifiedById,modifiedTimestamp attribute for collecting event
          formData = { ...formData, modifiedByName: userName, modifiedById: userId, modifiedTimestamp: moment().format(DATE_TIME_TWO_FORMAT)};
          onOk(formData, onToggleModal, wasDropOutRule, expandedLength);
        }
      } else if(allErrorList.length > 0) {
        form.setFields(allErrorList);
      }
    });
  };
  //defect:COT-4634,Warning message is not being displayed when a new sub/no-sub rule is created when a never sub rule is existing for the site id - concept/ship to - original item combination
  const checkSwitchRuleType = (initValueData,formData,isToggle) => {
    if(isToggle){
      //when toggle sub/never sub
      if (initValueData && formData) {
        // when switch rule type
        if ((initValueData.ruleType === 'sub' || initValueData.ruleType === null || initValueData.ruleType === 'nosub') && !formData.ruleType) {
          //when switch sub to never sub
          message.warning(TOGGLE_SUB_TO_NEVER_SUB_WARNING_MESSAGE);
        } else if (initValueData.ruleType === 'neversub' && formData.ruleType) {
          //when switch never sub to never sub
          message.warning(TOGGLE_NEVER_SUB_TO_SUB_WARNING_MESSAGE);
        }else if(initValueData.ruleType === 'dropout' && !formData.ruleType){
          //defect:COT-5562,Warning message regarding existing dropout rule is not displayed when user tries to edit the dropout rule to never sub rule.
          message.warning(TOGGLE_ONLY_DROP_OUT_TO_SUB_WARNING_MESSAGE);
        }
      }
    }else{
      //on click save button
      if (initValueData && formData) {
        if (initValueData.ruleType === 'neversub' && initValueData.expandedItems === null
          && formData.ruleType === '' && formData.expandedItems !== null) {
          message.warning(TOGGLE_NEVER_SUB_TO_SUB_WARNING_MESSAGE);
        } else if ((initValueData.ruleType === 'sub' || initValueData.ruleType === null || initValueData.ruleType === 'nosub')
          && initValueData.expandedItems !== null
          && formData.ruleType === 'neversub' && formData.expandedItems === null) {
          message.warning(TOGGLE_SUB_TO_NEVER_SUB_WARNING_MESSAGE);
        }else if(initValueData.ruleType === 'dropout'
        && (formData.ruleType === 'neversub' && formData.expandedItems === null)){
          //defect:COT-5562,Warning message regarding existing dropout rule is not displayed when user tries to edit the dropout rule to never sub rule.
          message.warning(TOGGLE_ONLY_DROP_OUT_TO_SUB_WARNING_MESSAGE);
        }
      }
    }
  }
  //add by jennifer
  //defect:COT-4991,sub ratio can accept valid numeric values with 0 appended in the front (e.g.: 09,080,etc)
  const validateSubRtio=(rule, value, callback)=>{
    const reg = new RegExp('^(((?!0+(?:\.0+)?$)(([1-9]{1}\\d{0,2})|(0{1}))(\\.\\d{1,2}))|((?!0+$)[0-9]{1}\\d{0,2}))?$', 'g');
    const reg1 = new RegExp('^[^a-zA-Z]+$', 'g');
    const reg2=new RegExp('(^[0-9]+[\\.]{0,1}[0-9]*(?<!\\.)$)', 'g');
    if(value !== null && value !== "" && !reg1.test(value)) {
      callback('Invalid input! The sub ratio should be a value in the range 0.01 to 999.99!')
    }else if(value !== null && value !== "" && !reg.test(parseFloat(value))) {
      callback('Invalid input! The sub ratio should be a value in the range 0.01 to 999.99!')
    }else if(value !== null && value !== "" && !reg2.test(value)) {
      callback('Invalid input! The sub ratio should be a value in the range 0.01 to 999.99!')
    }
    callback();
  }
  const onReset = () => {
    //defect:COT-5235,Reset functionality is not working properly in EDIT sub rule pop up
    // Get initial values from initValueData
    let editVals = initValueData && transferFromResultToForm(initValueData)
    getDropOutRuleCreatedInfo(initValueData, dropOutRuleCreateInfo)
    if(initValueData && checkDropOutRule(initValueData)) {
      setIsExistDropOutRule(true)
    } else {
      setIsExistDropOutRule(false)
    }

    // Always show 4 sub rows after reset
    let initialSubItems = (editVals?.expandedSubItems || []).slice(0, 4);
    while (initialSubItems.length < 4) {
      initialSubItems.push({});
    }

    // For each row, if it was present initially (has substituteItem), keep all fields.
    // If it was filled by user after modal open (substituteItem is empty), clear only user-entered fields,
    // but retain subPriority, subRatio, modifiedByName, modifiedById, modifiedTimestamp.
    const clearedSubItems = initialSubItems.map((item, idx) => {
      if (item && item.substituteItem && item.substituteItem.trim() !== '') {
        // Initial row: keep as is
        return {
          ...item,
          subPriority: item.subPriority || `${idx + 1}`,
          //subRatio: item.subRatio === undefined || item.subRatio === null || item.subRatio === "" ? '1.00' : item.subRatio,
          subRatio: formatSubRatioForUi(item.subRatio),
          modifiedByName: item.modifiedByName || '',
          modifiedById: item.modifiedById || '',
          modifiedTimestamp: item.modifiedTimestamp || '',
        };
      } else {
        // Not initial: clear user fields, retain priority/ratio/modified
        return {
          ...item,
          substituteItem: '',
          substituteItemDescription: '',
          substituteBrand: '',
          substitutePack: '',
          substituteSize: '',
          substituteStorageCode: '',
          substituteUom: '',
          endDate: null,
          customerApprovalFlag: null,
          ruleType: 'sub',
          subPriority: item.subPriority || `${idx + 1}`,
          subRatio: item.subRatio === undefined || item.subRatio === null || item.subRatio === "" ? '1.00' : item.subRatio,
          modifiedByName: item.modifiedByName || '',
          modifiedById: item.modifiedById || '',
          modifiedTimestamp: item.modifiedTimestamp || '',
        };
      }
    });

    // Do NOT change no-sub logic
    let initialNoSubItems = editVals?.expandedNoSubItems || [];

    const formVals = {
      ...(editVals || {
        ruleType: true,
        ...initCreatedTimestampFields,
        ...initModifiedTimestampFields,
      }),
      expandedSubItems: clearedSubItems,
      expandedNoSubItems: initialNoSubItems,
    }
    const neverSubFlag = formVals.ruleType === false;
    setNeverSubFlag(neverSubFlag);
    setSaveBtnDisabled(false)
    form.resetFields();
    form.setFieldsValue(formVals);
    resetConceptData();
  };
  const onDeleteNeverSub = () => {
    let formData = form.getFieldsValue();
    formData = formattedSubmitFormData(formData);
    //COT-9112:BOS 2.0 -UI- Audit trail for manage subs, add modifiedByName,modifiedById,modifiedTimestamp attribute for collecting event
    formData = { ...formData, modifiedByName: userName, modifiedById: userId, modifiedTimestamp: moment().format(DATE_TIME_TWO_FORMAT) };
    resetConceptData();
    onDelete(formData, onToggleModal)
  };
  const onModalClose = () => {
    resetConceptData();
    onToggleModal();
  };
  const handleRemoveSubItem = (remove, name) => {
    let objFormValues = form.getFieldsValue();
    const { expandedSubItems, expandedNoSubItems, ruleType } = objFormValues;
    if (expandedSubItems && expandedSubItems[name]) {
      const { subPriority, subRatio, ruleType } = expandedSubItems[name];
      expandedSubItems[name] = { subPriority, subRatio, ruleType: 'sub' };
    }

    form.setFieldsValue({ ...objFormValues, expandedSubItems });

    // Optionally, update save button state
    if (
      ruleType &&
      (!expandedSubItems || expandedSubItems.filter(item => item.substituteItem).length === 0) &&
      (!expandedNoSubItems || expandedNoSubItems.length === 0)
    ) {
      setSaveBtnDisabled(true)
    } else {
      setSaveBtnDisabled(false)
    }
    //remove(name)
  };
  const handleRemoveItem = (remove, name) => {
    const formVal = form.getFieldsValue()
    const { expandedSubItems, expandedNoSubItems, ruleType } = formVal
    if(ruleType && (!expandedSubItems || expandedSubItems.length === 0) && (!expandedNoSubItems || expandedNoSubItems.length === 1)) {
      setSaveBtnDisabled(true)
    } else {
      setSaveBtnDisabled(false)
    }
    remove(name)
  };
  const handleMoveSubItems = useCallback((move, fromIndex, toIndex) => {
    //index value start from 0
    if (fromIndex !== undefined && toIndex !== undefined) {
      let objFormValues = form.getFieldsValue();
      move(fromIndex, toIndex);
      const draggableItem = objFormValues.expandedSubItems.splice(fromIndex, 1);
      objFormValues.expandedSubItems.splice(toIndex, 0, draggableItem[0]);
      objFormValues.expandedSubItems.forEach((item, index) => {
        item.subPriority = `${index + 1}`;
        if (index <= Math.max(fromIndex, toIndex) && index >= Math.min(fromIndex, toIndex)) {
          item.modifiedByName = userName;
          item.modifiedById = userId;
          item.modifiedTimestamp = moment().format(DATE_TIME_TWO_FORMAT);
        }
      });
      form.setFieldsValue(objFormValues);
    }
  }, []); //eslint-disable-line
  const dropProduct = (label, key, fields, product) => {
    const formVal = form.getFieldsValue();
    let productEndDate = formVal[`endDate_${product.supc}`];
    let productSubRatio = formVal[`subRatio_${product.supc}`];
    const uom = initialValues.originalUom;
    let currFields = {
      substituteItem: product.supc,
      substituteBrand: null,   //COT-9714, reset brand,substituteItemDescription,substitutePack,substituteSize,substituteStorageCode,substituteUom to null when drop product, will validate sub item on sub item input onblur
      substituteItemDescription: null,
      substitutePack: null,
      substituteSize: null,
      substituteStorageCode: null,
      //substituteUom: null,
      substituteUom: uom,
    }
    //COT-9714,If changed subRatio and endDate in search result,should update subRatio and endDate in formVal,otherwise,show the old value
    if(label === 'expandedSubItems' && !_.isEmpty(productSubRatio)){
      currFields.subRatio = productSubRatio;
    }
    if(!_.isEmpty(productEndDate)){
      currFields.endDate = productEndDate;
    }
    formVal[label][key] = {
      ...formVal[label][key],
      ...currFields,
      ...initModifiedTimestampFields,
    }
    form.setFieldsValue(formVal);
  }
  const renderDraggableSubsRow = useCallback((key, name, fields, label, move, remove, ...resetField) => {
    return (
      <DraggableSubsRow
        key={key}
        name={name}
        fields={fields}
        label={label}
        move={move}
        remove={remove}
        {...resetField}
      />
    );
  }, []); //eslint-disable-line
  const DraggableSubsRow = ({ name, fields, label, move, remove, ...resetField }) => {
    const ref = useRef();
    const inputRef = useRef();
    const [{ handlerId }, drop] = useDrop({
      accept: ['draggableSubItem','draggableRecommandProduct'],
      collect: monitor => ({
        handlerId: monitor.getHandlerId(),
      }),
      hover(item, monitor) {
        if(monitor.getItemType() ===  'draggableSubItem'){
        if (!ref.current) {
          return;
        }
        const dragIndex = item.name;
        const hoverIndex = name;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return;
        }
        // Determine rectangle on screen
        const hoverBoundingRect = ref.current?.getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
        // Time to actually perform the action
        handleMoveSubItems(move, dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.name = hoverIndex;
        }
      },
      end:(item,monitor)=>{
        if(!monitor.didDrop()){
          //if drop not completed properly,will reset draged id
          setDragedElementId(null);
          setTimeout(() => {
            const tableBody = document.querySelector('.ant-table-body');
            if (tableBody) tableBody.focus();
          }, 100);
        }
      },
      drop: (item,monitor)=> {
        if (scrollIntervalRef.current) {
          clearInterval(scrollIntervalRef.current);
          scrollIntervalRef.current = null;
          scrollDirectionRef.current = null;
        }
        if (monitor.getItemType() === 'draggableRecommandProduct') {
          if (item.product) {
            dropProduct(label, name, fields,item.product);
            setTimeout(() => inputRef.current?.focus(),100);
          }
          setDragedElementId(null);
           setTimeout(() => {
            const tableBody = document.querySelector('.ant-table-body');
            if (tableBody) tableBody.focus();
          }, 100);
        }
      },
    });
    const [{ isDragging }, drag] = useDrag({
      type: 'draggableSubItem',
      item: () => {
        return { name };
      },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    });
    drop(drag(ref));
    return (  
    
      <Row
        ref={ref}
        data-handler-id={handlerId}
        gutter={6}
        className={`sub-item-list-item draggle-item ${isDragging ? 'dragging' : ''}`}
        
      >
        <Col span={3} className="flex align-items-center">
          <div className="toggle-desc">Sub</div>
          <Form.Item {...resetField} name={[name, 'ruleType']} valuePropName="checked">
            <Switch
              className="subs-switch"
              size="small"
              defaultChecked
              onChange={checked => onToggleSubNonRuleType(checked, name)}
            />
          </Form.Item>
          <div className="toggle-desc">Not-Suit-Sub</div>
        </Col>
        <Col span={2}>
          <Form.Item {...resetField} name={[name, 'subPriority']}>
            <Input disabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            {...resetField}
            className="sub-item-position"
            name={[name, 'substituteItem']}
            validateTrigger={['onChange', 'onBlur']}
            rules={[
              {
                // Only validate if user has entered something in this row
                validator: (rule, value, callback) => {
                  // If all fields in this row are empty, skip validation
                  const row = form.getFieldValue(['expandedSubItems', name]);
                  const isRowEmpty =
                    !row?.substituteItem &&
                    !row?.substituteBrand &&
                    !row?.substituteItemDescription &&
                    !row?.substitutePack &&
                    !row?.substituteSize &&
                    !row?.substituteStorageCode &&
                    !row?.substituteUom &&
                    !row?.endDate &&
                    !row?.customerApprovalFlag;
                  if (isRowEmpty) {
                    callback(); // No validation error for empty row
                  } else if (!value || value.trim() === '') {
                    callback('Please input Sub Item!');
                  } else {
                    // Existing duplicate and format checks
                    handleSubItemValidator(rule, value, callback, 'expandedSubItems', name);
                  }
                },
                validateTrigger: ['onBlur', 'onChange'],
              },
            ]}
            //defect:COT-5561,trim extra space for original item and substituteItem when onchange
            getValueFromEvent={e => {
              return e.target.value.replace(/\s/g,'');
            }}
          >
            <Input
              onChange={e =>handleItemChange(e.target.value.replace(/\s/g,''), 'substituteItem', name, 'expandedSubItems')}
              onPressEnter={e => handleItemPressEnter(e)}
              ref={inputRef}
            />
          </Form.Item>
          <SubDetail name={name} form={form} label='expandedSubItems' />
        </Col>
        <Col span={2}>
          <Form.Item
            {...resetField}
            name={[name, 'subRatio']}
            rules={[
              { required: false },
              //add by jennifer
              //defect:COT-4991,sub ratio can accept valid numeric values with 0 appended in the front (e.g.: 09,080,etc)
              // { pattern: new RegExp('^(((?!0+(?:\.0+)?$)(([1-9]{1}\\d{0,2})|(0{1}))(\\.\\d{1,2}))|([0-9]{1}\\d{0,2}))?$', 'g'),
              //  message: 'Invalid input! The sub ratio should be a value in the range 0.01 to 999.99!'},
              {validator: (rule, value, callback) => validateSubRtio(rule, value, callback)}
            ]}
          >
            <Input
              onChange={e => handleItemChange(e.target.value, 'subRatio', name, 'expandedSubItems')}
              onBlur={e => {
                const value = e.target.value;
                if (value && value.trim() !== '') {
                  const floatValue = parseFloat(value);
                  if (!isNaN(floatValue)) {
                    const formattedValue = floatValue.toFixed(2);
                    const objFormValues = form.getFieldsValue();
                    objFormValues.expandedSubItems[name] = {
                      ...objFormValues.expandedSubItems[name],
                      subRatio: formattedValue,
                    };
                    form.setFieldsValue(objFormValues);
                  }
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item {...resetField} name={[name, 'endDate']}>
            <DatePicker
              disabledDate={disablePastDt}
              onChange={(date, dateString) =>
                handleItemChange(date, 'endDate', name, 'expandedSubItems')
              }
              format={SLASH_DATE_FORMAT}
            />
          </Form.Item>
        </Col>
        {/* {title === 'Edit sub rule' && (
          <Col span={4} style={{display:'inline',marginTop: '-6px'}}>
            <Form.Item
              className="flex align-items-center createdByName font-size-14-bold"
              name={[name, 'createdByName']}
            >
              <CustomLabel />
            </Form.Item>
            <div className="flex align-items-center series-tips-timestamp-items">
              <Form.Item className="tips-content-item" name={[name, 'createdById']}>
                <CustomLabel />
              </Form.Item>
              <Form.Item className="tips-content-item" name={[name, 'createTimestamp']}>
                <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
              </Form.Item>
            </div>
          </Col>
        )} */}
        <Col span={4}>
          <Form.Item
            className="flex align-items-center createdByName font-size-14-bold"
            name={[name, 'modifiedByName']}
          >
            <CustomLabel />
          </Form.Item>
          <div className="flex align-items-center series-tips-timestamp-items">
            <Form.Item className="tips-content-item" name={[name, 'modifiedById']}>
              <CustomLabel />
            </Form.Item>
            <Form.Item className="sub-item-position" name={[name, 'modifiedTimestamp']}>
              <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
            </Form.Item>
          </div>
        </Col>
        <Col span={2}>
        <Form.Item {...resetField} name={[name, 'customerApprovalFlag']} valuePropName="checked">
            <Checkbox onChange={(e) =>
                handleItemChange(e.target.checked, 'customerApprovalFlag', name, 'expandedSubItems')
              }></Checkbox>
          </Form.Item>
        </Col>
        <Col className="flex align-items-center">
          <Button onClick={() => handleRemoveSubItem(remove, name)} className={'no-border'}>
            <FontAwesomeIcon icon={faTrash} color="#6b6b6c" style={{ height: "13px", width: "13px" ,paddingRight:'20px'}}/> 
          </Button>
        </Col>
      </Row>
      
    );
  };
  const renderDraggableToNoSubsRow = useCallback(
    (key, name, fields, label, move, remove, ...resetField) => {
      return (
        <DraggableNoSubsRow
          key={key}
          name={name}
          fields={fields}
          move={move}
          remove={remove}
          label={label}
          {...resetField}
        />
      );
    },
    [],
  );
  const DraggableNoSubsRow = ({ key, name, fields, move, remove, label, ...resetField }) => {
    const inputRef = useRef();
    const [{ handlerId }, drop] = useDrop({
      accept: 'draggableRecommandProduct',
      collect: monitor => ({
        isOver: monitor.isOver(),
      }),
      end:(item,monitor)=>{
        //if drop not completed properly,will reset draged id
        if(!monitor.didDrop()){
          setDragedElementId(null);
        }
      },
      drop: item => {
        if (item.product) {
          // put product-card data in Row
          dropProduct(label, name,fields, item.product);
          setTimeout(() => inputRef.current?.focus(),100);
        }
        setDragedElementId(null);
      },
    });
  
    return (
      <Row key={key} gutter={6} className="sub-item-list-item" ref={drop} data-handler-id={handlerId}>
        <Col span={3} className="flex align-items-center">
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.expandedNoSubItems?.[name]?.ruleType !== currentValues.expandedNoSubItems?.[name]?.ruleType} >
            {({ getFieldValue }) => {
              const ruleType = getFieldValue(['expandedNoSubItems', name, 'ruleType']);
              return ruleType !== 'dropout' ? (
                <>
                  <div className="toggle-desc">Sub</div>
                  <Form.Item
                    {...resetField}
                    name={[name, 'ruleType']}
                    valuePropName="checked"
                  >
                    <Switch
                      className="subs-switch"
                      size="small"
                      onChange={checked => onToggleSubNonRuleType(checked, name)}
                    />
                  </Form.Item>
                  <div className="toggle-desc">Not-Suit-Sub</div></>
              ) : <>
                <Col className='flex align-items-center' style={{paddingRight:'10.5px', justifyContent:'center'}}>
                <PlayCircleFilled  rotate={90} style={{ fontSize: '16px', color: '#db6f6f'  }}/>
                </Col>
                <Col span={10} style={{paddingTop:'4px'}}><span style={{fontWeight:'600',color:'#194F72'}}>Drop Out</span></Col>
              </>;
            }}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.expandedNoSubItems?.[name]?.ruleType !== currentValues.expandedNoSubItems?.[name]?.ruleType} >
            {({ getFieldValue }) => {
              const ruleType = getFieldValue(['expandedNoSubItems', name, 'ruleType']);
              return ruleType !== 'dropout' ? (<>
                <Form.Item
                  {...resetField}
                  className="sub-item-position"
                  name={[name, 'substituteItem']}
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      validateTrigger: ['onBlur'],
                      validator: (rule, value, callback) => handleSubItemValidator(rule, value, callback, 'expandedNoSubItems', name,),
                    },
                    {
                      validateTrigger: ['onChange', 'onBlur'],
                      required: (dropoutCheck !== null && dropoutCheck) ? false : true,
                      message: 'Please input Not-Suit-Sub Item!',
                    },
                  ]}
                  //defect:COT-5561,trim extra space for original item and substituteItem when onchange 
                  getValueFromEvent={e => {
                    return e.target.value.replace(/\s/g, '');
                  }}
                >
                  <Input
                    onChange={e => handleItemChange(e.target.value.replace(/\s/g, ''), 'substituteItem', name, 'expandedNoSubItems',)}
                    onPressEnter={e => handleItemPressEnter(e)}
                    ref={inputRef}
                  />
                </Form.Item>
                <SubDetail name={name} form={form} label='expandedNoSubItems' /></>) : null;
            }}</Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item {...resetField} name={[name, 'endDate']}>
            <DatePicker
              disabledDate={disablePastDt}
              onChange={(date, dateString) => handleItemChange(date, 'endDate', name, 'expandedNoSubItems')}
              format={SLASH_DATE_FORMAT}
            />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.expandedNoSubItems?.[name]?.ruleType !== currentValues.expandedNoSubItems?.[name]?.ruleType} >
            {({ getFieldValue }) => {
              const ruleType = getFieldValue(['expandedNoSubItems', name, 'ruleType']);
              let REASON_CODE_OPTION = REASON_CODE;
              if (ruleType === 'dropout') {
                REASON_CODE_OPTION = DROP_OUT_REASON_CODE;
              }
              return (
                <Form.Item
                  {...resetField}
                  name={[name, 'reasonCode']}
                  rules={[{
                    required: (dropoutCheck !== null && dropoutCheck) ? false : true,
                    message: 'Please input Reason Code!'
                  }]}
                >
                  <Select
                    onChange={value => { ruleType === 'dropout' ? handleDropoutReasonChg(value, 'reasonCode', name, 'expandedNoSubItems') : handleItemChange(value, 'reasonCode', name, 'expandedNoSubItems') }}
                  >
                    {REASON_CODE_OPTION.map(item => {
                      return (
                        <Select.Option key={item.key} value={item.key}>
                          {item.key}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>)
            }}</Form.Item>
          <Form.Item hidden={true}
            {...resetField}
            name={[name, 'reasonDescription']}
          ></Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            className="createdByName font-size-14-bold"
            name={[name, 'modifiedByName']}
          >
            <CustomLabel />
          </Form.Item>
          <div className="flex align-items-center series-tips-timestamp-items">
            <Form.Item className="tips-content-item" name={[name, 'modifiedById']}>
              <CustomLabel />
            </Form.Item>
            <Form.Item className="sub-item-position" name={[name, 'modifiedTimestamp']}>
              <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
            </Form.Item>
          </div>
        </Col>
        <Col span={2}>
        <Form.Item {...resetField} name={[name, 'customerApprovalFlag']} valuePropName="checked">
            <Checkbox onChange={(e) =>
                handleItemChange(e.target.checked, 'customerApprovalFlag', name, 'expandedNoSubItems')
              }></Checkbox>
          </Form.Item>
        </Col>
        <Col className='flex align-items-center'>
          <Button onClick={() => handleRemoveItem(remove, name)} className={'no-border'}>
            <FontAwesomeIcon icon={faTrash} color="#6b6b6c" style={{ height: "13px", width: "13px" }} />
          </Button>
        </Col>
  
      </Row>
    );
  }
  const onSelectSubToggleModal = updateState => {
    updateState(prevState => {
      return !prevState;
    });
  };
  const handleSubSearch = (label, key = 0) => {
    form.validateFields(['site']).then(() => {
      const formVal = form.getFieldsValue()
      if(!formVal.originalUom) {
        let errorList = []
        errorList.push({
          "name": ["originalItem"],
          "errors": ['Invalid Original Item!'],
        })
        form.setFields(errorList)
        return
      }
      const isNum = validateNumericRegExp(formVal.nationalId)
      //cot-5366 if in edit sub screen will call validate item for getting kosher.
      if(title === 'Edit sub rule'){
        const itemValidformData = { opcoId: formVal.site, productId: formVal.originalItem };
        const tempData = {
          "site": formVal.site,
          "siteDesc": formVal.siteDesc,
          "nationalId": isNum ? '' : formVal.nationalId,
          "nationalName": isNum ? '' : formVal.nationalName,
          "customerNumber": isNum ? formVal.nationalId : '',
          "customerName": isNum ? formVal.nationalName : '',
          "conceptId": formVal.nationalId,
          "conceptName": formVal.nationalName,
          "originalItem": formVal.originalItem,
          "originalItemDescription": formVal.originalItemDescription,
          "originalItemUom": formVal.originalUom,
          "originalPack": formVal.originalPack,
          "originalSize": formVal.originalSize,
          // "kosher": productInfo.kosher,
          "originalBrand": formVal.originalBrand,
          "originalStorageCode": formVal.originalStorageCode,
          "casePrice": '---',
          "caseQuantity": '---',
          "isFromOuts": false,
          "label": label,
          "keyIndex": key,
        }
        fetchValidationItemData(itemValidformData).then(productInfo => {
          tempData.kosher = productInfo.kosher;
        }).catch(err => { /*COT-10361*/
          if (err && typeof err === 'object' && err.result === 'Failed' && err.errorMessage) {
            message.error(err.errorMessage);
          }
          tempData.kosher = false;
        }).finally(() => {
          setBaseData(tempData);
          onSelectSubToggleModal(setSelectSubModalVisible);
        })
      }else{
        setBaseData({
          "site": formVal.site,
          "siteDesc": formVal.siteDesc,
          "nationalId": isNum ? '' : formVal.nationalId,
          "nationalName": isNum ? '' : formVal.nationalName,
          "customerNumber": isNum ? formVal.nationalId : '',
          "customerName": isNum ? formVal.nationalName : '',
          "conceptId": formVal.nationalId,
          "conceptName": formVal.nationalName,
          "originalItem": formVal.originalItem,
          "originalItemDescription": formVal.originalItemDescription,
          "originalItemUom": formVal.originalUom,
          "originalPack": formVal.originalPack,
          "originalSize": formVal.originalSize,
          "kosher": formVal.originalItemKosher,
          "originalBrand": formVal.originalBrand,
          "originalStorageCode": formVal.originalStorageCode,
          "casePrice": '---',
          "caseQuantity": '---',
          "isFromOuts": false,
          "label": label,
          "keyIndex": key,
        })
        onSelectSubToggleModal(setSelectSubModalVisible);
      }
      fetchRecommendedProducts({
        "searchBy": "Item Description",
        "searchInput": formVal.originalItemDescription,
        "site": [formVal.site],
        "originalItemUom": formVal.originalUom,
        "originalItem": formVal.originalItem,
        "nationalId": isNum ? '' : formVal.nationalId,
        "customerNumber": isNum ? formVal.nationalId : '',
        "isFromOuts": false,
        "searchFor": "Recommended Products",
      }).catch(err => {
        //message.error(`Search Recommended Substitutions Failed, please try again.`);
        message.error(`${err}`); //COT-10152
      });
    }).catch(() => {
    })
  };
  const selectSub = (product, label, _key, subRatio, endDate) => {
    label = label || 'expandedSubItems';
    let formVal = form.getFieldsValue() || {};

    // Ensure the array exists and is always 4 elements
    if (!Array.isArray(formVal[label])) {
      formVal[label] = [];
    }
    while (formVal[label].length < 4) {
      formVal[label].push({});
    }

    // Find the first empty row (where substituteItem is missing or empty)
    const emptyIndex = formVal[label].findIndex(
      row => !row.substituteItem || String(row.substituteItem).trim() === ''
    );

    if (emptyIndex === -1) {
      message.warning('All 4 Sub rows are filled. Please clear a row before adding.');
      return;
    }

    // Check for duplicate substituteItem in expandedSubItems and expandedNoSubItems
    const isDuplicateSub = formVal.expandedSubItems &&
      formVal.expandedSubItems.some(
        row => row.substituteItem && row.substituteItem.trim() === product.supc.trim()
      );
    const isDuplicateNoSub = formVal.expandedNoSubItems &&
      formVal.expandedNoSubItems.some(
        row => row.substituteItem && row.substituteItem.trim() === product.supc.trim()
      );
    // Also check against originalItem
    if (
      isDuplicateSub ||
      isDuplicateNoSub ||
      (formVal.originalItem && product.supc.trim() === formVal.originalItem.trim())
    ) {
      message.error('Duplicated Sub/Not-Suit-Sub Item!');
      return;
    }

    // Run all validations for this sub item before adding (async)
    handleSubItemValidator(
      {}, // rule param not used in your validator
      product.supc,
      (errorMsg) => {
        if (errorMsg) {
          message.warning(errorMsg);
          return;
        }
        //Bug fix COT-10138
        const endDateKey = `endDate_${product.supc}`;
        const selectedEndDate = formVal[endDateKey] || endDate || null;

        // If validation passes, add the item
        formVal[label][emptyIndex] = {
          ...formVal[label][emptyIndex],
          substituteItem: product.supc,
          substituteItemDescription: product.item_description,
          substituteBrand: product.sysco_brand,
          substitutePack: product.pack,
          substituteSize: product.size,
          substituteStorageCode: convertStorageCode(product.site_details[0].storageCode),
          substituteUom: product.site_details[0].originalItemUom,
          subRatio: subRatio || '1.00',
          //endDate: endDate || null,
          endDate: selectedEndDate, 
          customerApprovalFlag: null,
          ruleType: 'sub',
          subPriority: `${emptyIndex + 1}`,
          ...initModifiedTimestampFields,
        };

        form.setFieldsValue({ ...formVal });
      },
      label,
      emptyIndex
    );
  };
  const renderSelectSubModal = (
    <ManageOutsOperateModal
      title="ADDSUB"
      isModalVisible={isSelectSubModalVisible}
      footer={false}
      width={1210}
      onToggleModal={() => {onSelectSubToggleModal(setSelectSubModalVisible); resetRecommendedProducts(); resetSubstituteProducts();}}
      okText="Sub"
      baseData={baseData}
      onSelectSub={selectSub}
      fromSubs={true}
      idle={()=>{}}
    />
  );
  const dragInitValues = {
      "site": [],
      "originalItemUom": "",
      "originalItem": "",
      "nationalId": null,
      "customerNumber": "",
      "isFromOuts": false,
      "totalOuts": 0,
      "originalAsoh": recommendedProducts ? recommendedProducts.originalAsoh : "",
      "originalPrice": recommendedProducts ? recommendedProducts.originalPrice : "",
      "recommendedProducts": recommendedProducts ? 
            ((recommendedProducts.data && recommendedProducts.data.length) ? deleteOriginalItem(recommendedProducts.data, initValueData?.originalItem) : null) : null,
  }
  const [dragInitialValues,setDragInitialValues] = useState({...dragInitValues,...initValueData,originalItemUom: initValueData?.originalUom});
  const [dragRecommendedProducts, setDragRecommendProducts] = useState({
    "recommendedProducts": [],
    "originalAsoh": '',
    "originalPrice": '',
    "originalPricePerUuom": '',
    "originalPricePerNetWeight": '',
    "originalUuomOrNetWeight": 'NA',
  });  
  useEffect(() => {
    const formCurr = form.getFieldsValue();
    form.setFieldsValue({ ...formCurr, originalAsoh: recommendedProducts?.originalAsoh, originalPrice: recommendedProducts?.originalPrice });
    setDragRecommendProducts({
      "recommendedProducts": recommendedProducts?.data,
      "originalAsoh": recommendedProducts?.originalAsoh,
      "originalPrice": recommendedProducts?.originalPrice,
      "originalPricePerUuom": recommendedProducts?.originalPricePerUuom || '',
      "originalPricePerNetWeight": recommendedProducts?.originalPricePerNetWeight || '',
      "originalUuomOrNetWeight": recommendedProducts?.originalUuomOrNetWeight || 'NA',
    });
  }, [recommendedProducts, form]); 
const recPricePerUuom = recommendedProducts?.originalPricePerUuom;
const recPricePerNetWeight = recommendedProducts?.originalPricePerNetWeight;
const recUuomOrNetWeight = recommendedProducts?.originalUuomOrNetWeight;

useEffect(() => {
  if (substituteProducts && 'originalUuomOrNetWeight' in substituteProducts) {
    setDragRecommendProducts(prev => ({
      ...prev,
      "originalPricePerUuom": substituteProducts.originalPricePerUuom || '',
      "originalPricePerNetWeight": substituteProducts.originalPricePerNetWeight || '',
      "originalUuomOrNetWeight": substituteProducts.originalUuomOrNetWeight || 'NA',
    }));
  } else if (!substituteProducts) {
    setDragRecommendProducts(prev => ({
      ...prev,
      "originalPricePerUuom": recPricePerUuom || '',
      "originalPricePerNetWeight": recPricePerNetWeight || '',
      "originalUuomOrNetWeight": recUuomOrNetWeight || 'NA',
    }));
  }
}, [substituteProducts, recPricePerUuom, recPricePerNetWeight, recUuomOrNetWeight]);
  const [dragedElementId,setDragedElementId] = useState(null);
    const [lastY, setLastY] = useState(null);
    const SCROLL_EDGE_OFFSET = 50; // px from top/bottom to start scrolling
      const SCROLL_SPEED_FIVE = 5;
      const SCROLL_SPEED_EIGHT = 8;
      const [scrollSpeed,setScrollSpeed] = useState(SCROLL_SPEED_FIVE);
      useEffect(()=>{
        if(recommendedProducts && recommendedProducts?.data.length > 5 ){
          setScrollSpeed(SCROLL_SPEED_EIGHT);
        }
      },[recommendedProducts]);
  useEffect(() => {
      if (isModalVisible) {
        setTimeout(() => {
          // Make modal body focusable
          const modalBody = document.querySelector('.manage-subs-ogm-subs-operate-modal .ant-modal-body');
          if (modalBody) {
            modalBody.setAttribute('tabindex', '0');
          }
          // Prevent close button from being focused
          const closeBtn = document.querySelector('.manage-subs-ogm-subs-operate-modal .ant-modal-close');
          if (closeBtn) {
            closeBtn.setAttribute('tabindex', '-1');
          }
        }, 200);
      }
    }, [isModalVisible]);
    const scrollIntervalRef = useRef(null);
      const scrollDirectionRef = useRef(null);
      useEffect(() => {
      return () => {
        if (scrollIntervalRef.current) {
          clearInterval(scrollIntervalRef.current);
          scrollIntervalRef.current = null;
          scrollDirectionRef.current = null;
        }
      };
    }, []);
    useEffect(() => {
      // Handler to clear scroll interval on any drag end (even outside drop zones)
      const handleGlobalDragEnd = () => {
        if (scrollIntervalRef.current) {
          clearInterval(scrollIntervalRef.current);
          scrollIntervalRef.current = null;
          scrollDirectionRef.current = null;
        }
      };
      document.addEventListener('dragend', handleGlobalDragEnd);
      return () => {
        document.removeEventListener('dragend', handleGlobalDragEnd);
        // Also clear on unmount
        handleGlobalDragEnd();
      };
    }, []);

  const expandedSubItemsFilled = (() => {
    let items = (initialValues.expandedSubItems || []).slice(0, 4);
    while (items.length < 4) {
      items.push({});
    }
    // Always assign subPriority 1-4 and prefill subRatio for UI
    return items.map((item, idx) => ({
      ...item,
      subPriority: `${idx + 1}`,
      // subRatio: item.subRatio === undefined || item.subRatio === null || item.subRatio === "" ? '1.00' : item.subRatio,
      subRatio: formatSubRatioForUi(item.subRatio),
    })).slice(0, 4);
  })();
    const scrollAuto = useCallback((e) => {
      if (!dragedElementId) return;
      const modelElement = document.querySelector('.manage-subs-ogm-subs-operate-modal .ant-modal-body');
      if (!modelElement) return;
    
      const rect = modelElement.getBoundingClientRect();
      const mouseY = e.clientY;
      const topEdge = rect.top + SCROLL_EDGE_OFFSET;
      const bottomEdge = rect.bottom - SCROLL_EDGE_OFFSET;
    
      let direction = null;
      if (mouseY < topEdge) direction = 'up';
      else if (mouseY > bottomEdge) direction = 'down';
    
      // If not near edge, always clear interval
      if (!direction) {
        if (scrollIntervalRef.current) {
          clearInterval(scrollIntervalRef.current);
          scrollIntervalRef.current = null;
          scrollDirectionRef.current = null;
        }
        return;
      }
      // If direction changed, clear previous interval
      if (scrollDirectionRef.current !== direction && scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    
      // Start interval if needed
      if (direction && !scrollIntervalRef.current) {
        scrollDirectionRef.current = direction;
        scrollIntervalRef.current = setInterval(() => {
          if (direction === 'up') {
            modelElement.scrollTop -= scrollSpeed;
          } else if (direction === 'down') {
            modelElement.scrollTop += scrollSpeed;
          }
        }, 10);
      }
    }, [dragedElementId, scrollSpeed]);
    const dragStart = (e) => {
      setLastY(e.clientY);
    }
    useEffect(() => {
      if (!dragedElementId) return;
      const dragedElement = document.getElementById(dragedElementId);
      dragedElement.addEventListener('dragstart', dragStart);
      dragedElement.addEventListener('drag', scrollAuto);
      return () => {
        if (dragedElement) {
          dragedElement.removeEventListener('drag', scrollAuto);
          dragedElement.removeEventListener('dragstart', dragStart)
        }
      }
    }, [lastY, dragedElementId]);// eslint-disable-line
  return (
    <>
    <Modal className="manage-subs-ogm-subs-operate-modal"
      title={title}
      visible={isModalVisible}
      onCancel={onModalClose}
      cancelText={cancelText || 'Close'}
      okText={okText || 'Save'}
      destroyOnClose={true}
      maskClosable={false}
      footer={footer || true}
      width={width || 520}
      // style={{maxHeight:'90vh',overflowY:'auto',scrollBehavior:'smooth',scrollSnapType:'y'}}
    >
    <DndProvider backend={HTML5Backend}>
      <Spin
        spinning={
          loading ||
          fetchAddedSubsDataPending ||
          fetchValidationItemDataPending ||
          fetchValidationCustomerDataPending ||
          validateSubItemPending
        }
      >
        
        <Form
          form={form}
          name="manage-subs-operate-form"
          className="operate-form"
          autoComplete="off"
          //initialValues={initialValues}
              initialValues={{
                ...initialValues,
                expandedSubItems: expandedSubItemsFilled
              }}
        >
          {formattedRecord && ( //this header shows just for Edit screen
              <Row gutter={1} justify="space-between" className="sub-item-header">
                <Col span={2}>
                  <Form.Item className="form-label static-form-item-value" name="site" label="Site ID:">
                    <CustomLabel />
                  </Form.Item>
                  <Form.Item className="tips-content-item edit-site-tip" name="siteDesc">
                    <CustomLabel />
                  </Form.Item>
                </Col>
                <Col span={ neverSubFlag ? 5 : 4} >
                  <Form.Item
                    className="form-label static-form-item-value"
                    name="nationalId"
                    //revert defect:COT-4950
                    label='Group/Ship To'
                  >
                    <CustomLabel />
                  </Form.Item>
                  <Form.Item className="tips-content-item edit-concept-tip" name="nationalName">
                    <CustomLabel />
                  </Form.Item>
                </Col>
                <Col span={ neverSubFlag ? 4 : 4}>
                  <Form.Item
                    className="form-label static-form-item-value"
                    name="originalItem"
                    label='Original Item'
                  >
                    <CustomLabel />
                  </Form.Item>
                  <div className="flex align-items-center series-edit-tips-content-items">
                    <Form.Item className="tips-content-item" name="originalItemDescription">
                      <CustomLabel suffix=" " />
                    </Form.Item>
                  </div>
                  <div className="flex align-items-center series-edit-tips-content-items-1">
                    <Form.Item className="tips-content-item" name="originalUom">
                      <CustomLabel suffix=" | " />
                    </Form.Item>
                    <Form.Item className="tips-content-item" name="originalPack">
                      <CustomLabel suffix="/" />
                    </Form.Item>
                    <Form.Item className="tips-content-item" name="originalSize">
                      <CustomLabel suffix=" | " />
                    </Form.Item>
                    <Form.Item className="tips-content-item" name="originalBrand">
                      <CustomLabel suffix=" | " />
                    </Form.Item>
                    <Form.Item className="tips-content-item" name="originalStorageCode">
                      <CustomLabel />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={2} className='uom-dropdown'>
                  <Form.Item
                    className="static-form-item-value"
                    label="UOM"
                    name="originalUom"
                  >
                    <CustomLabel/>
                  </Form.Item>
                </Col>
                  <Col span={3}>
                    <Form.Item
                      className="form-label static-form-item-value"
                      label="ASOH"
                      name="originalAsoh"
                    >
                    <CustomLabelWithValue name="originalAsoh" itemVal={dragRecommendedProducts?.originalAsoh} suffix={` ${initValueData.originalUom}`} />
                    </Form.Item>
                    <Form.Item className="tips-content-item" name="originalPrice" style={{ left: '50px' }}>
                      <CustomLabelWithValue
                        prefix={dragRecommendedProducts?.originalPrice === '---' ? '' : '$'}
                        name="originalPrice"
                        itemVal={dragRecommendedProducts?.originalPrice === '---' ? 'Market Price' : dragRecommendedProducts?.originalPrice} />
                    </Form.Item>
                    {/* <Form.Item className="tips-content-item" name="originalUuomOrNetWeight" style={{ left: '50px', top: '28px' }}>
                      <Tooltip
                        title={
                          dragRecommendedProducts.originalPricePerUuom && dragRecommendedProducts.originalPricePerUuom !== 'NA' ? (
                            <div>Price Per UUOM : $ {dragRecommendedProducts.originalPricePerUuom}</div>
                          ) : dragRecommendedProducts.originalPricePerNetWeight && dragRecommendedProducts.originalPricePerNetWeight !== 'NA' ? (
                            <div>Price Per NetWeight : $ {dragRecommendedProducts.originalPricePerNetWeight}</div>
                          ) : (
                            <div>No price details available</div>
                          )
                        }
                      >
                        <span style={{ cursor: 'pointer', display: 'inline-block' }}>
                          <CustomLabelWithValue
                            prefix={dragRecommendedProducts.originalUuomOrNetWeight === 'NA' || dragRecommendedProducts.originalUuomOrNetWeight === '' ? '' : '$'}
                            name="originalUuomOrNetWeight"
                            itemVal={dragRecommendedProducts.originalUuomOrNetWeight}
                            className="mobile-subtext"
                          />
                        </span>
                      </Tooltip>
                    </Form.Item> */}
                    <Form.Item className="tips-content-item" name="originalUuomOrNetWeight" style={{ left: '50px', top: '28px' }}>
                      <Tooltip
                        title={
                          dragRecommendedProducts.originalPricePerNetWeight && dragRecommendedProducts.originalPricePerNetWeight !== 'NA' ? (
                            <div>Price Per Net Weight : $ {dragRecommendedProducts.originalPricePerNetWeight}</div>
                          ) : (
                            <div>NA</div>
                          )
                        }
                      >
                        <span style={{ cursor: 'pointer', display: 'inline-block' }}>
                          <CustomLabelWithValue
                            prefix={dragRecommendedProducts.originalPricePerNetWeight && dragRecommendedProducts.originalPricePerNetWeight !== 'NA' ? '$' : ''}
                            name="originalUuomOrNetWeight"
                            itemVal={dragRecommendedProducts.originalPricePerNetWeight && dragRecommendedProducts.originalPricePerNetWeight !== '' ? dragRecommendedProducts.originalPricePerNetWeight : 'NA'}
                            className="mobile-subtext"
                          />
                        </span>
                      </Tooltip>
                    </Form.Item>
                  </Col>
                  {dragRecommendedProducts?.kosher && (
                    <Col span={2}>
                      <Form.Item className="static-form-item-value">
                        <span>K</span>
                      </Form.Item>
                    </Col>
                  )}
                {(neverSubFlag || dropoutCheck)&& (
                  <Col span={4}>
                    <Form.Item
                      className="form-label static-form-item-value"
                      label="Effective End Date"
                      name="endDate"
                    >
                      <DatePicker
                        disabledDate={disablePastDt}
                        format={SLASH_DATE_FORMAT}
                        onChange = {(date,dateString)=>handleItemChange(date, 'endDate')}
                      />
                    </Form.Item>
                  </Col>
                )}
                {!dropoutCheck &&
                  <Col span={3} className="flex sub-neversub-btn">
                    <div className="toggle-desc">Sub</div>
                    <Form.Item name="ruleType" valuePropName="checked">
                      <Switch
                        className="subs-switch"
                        size="small"
                        defaultChecked={formattedRecord.expandedItems ? true : false}
                        onChange={checked => onToggleSubNeverRuleType(checked)}
                      />
                    </Form.Item>
                    <div className="toggle-desc">Never-Sub</div>
                  </Col>
                }
              </Row>
            )}
          {(isExistDropOutRule && !neverSubFlag) && (
            <Row gutter={1} className="sub-item-header" style={{marginTop:"20px",marginLeft:"0px"}}>
              {/* <Col className='flex align-items-center' style={{paddingRight:'10.5px', justifyContent:'center'}}>
              <PlayCircleFilled  rotate={90} style={{ fontSize: '16px', color: '#db6f6f'  }}/>
              </Col>
              <Col span={2} style={{paddingTop:'4px'}}><span style={{fontWeight:'600',color:'#194F72'}}>Drop Out</span></Col> */}
              <Col>
                {/* <Form.Item name="dropOutRuleEndDate" label="Effective End Date">
                  <DatePicker
                    disabledDate={disablePastDt}
                    // onChange={(date, dateString) => handleItemChange(date, 'endDate', name, 'expandedNoSubItems')}
                    format={SLASH_DATE_FORMAT}
                  />
                </Form.Item> */}
                  {/* if drop out rule need pass reason code and reason description to web service  when update substitution*/}
                  <div style={{ display: 'none' }}>
                    <Form.Item name="reasonCode">
                    </Form.Item>
                    <Form.Item name="reasonDescription">
                    </Form.Item>
                  </div>
              </Col>
               {/*<Col>
                <Button onClick={() => setIsExistDropOutRule(false)} className={'no-border'}>
                  <FontAwesomeIcon icon={faTrash} color="#6b6b6c" style={{ height: "13px", width: "13px" }}/> 
                </Button>
              </Col>*/}
            </Row>
          )}
          {(!neverSubFlag && !dropoutCheck)&& (
            <Row>
              <Col span={24}>
                <Row gutter={6} className="sub-item-list-header">
                  <Col span={3}></Col>
                  <Col span={2}>Priority</Col>
                  <Col span={6}>Sub Item</Col>
                  <Col span={2}>Sub Ratio</Col>
                  <Col span={3}>Effective end date</Col>
                  {/* {title === 'Edit sub rule' && <Col span={4}>Created By</Col>} */}
                  <Col span={4}>Last Modified</Col>
                  <Col span={2}>Cust Approve</Col>
                  <Col style={{paddingRight:'20px'}}>Actions</Col>
                </Row>
                  <Form.List name="expandedSubItems">
                    {(fields, { add, move, remove }, { errors }) => (
                      <>
                        {fields.map(({ key, name, ...resetField }) =>
                          renderDraggableSubsRow(key, name, fields,"expandedSubItems", move, remove, resetField),
                        )}
                        {fields.length < 4 && ( //for sub item, it just can be added up to 4 row
                          <Row>
                            <Col span={1} offset={23}>
                              <Form.Item>
                                <Button
                                  className="subs-header-btn no-border"
                                  onClick={() => handleOperatedSubItems(add, true, fields, errors)}
                                  icon={<PlusOutlined />}
                                  title='Click + to add items to drag and drop'
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </Form.List>
              </Col>
            </Row>
          )}
          {!neverSubFlag && <SearchRecommendedProducts setDragedElementId={setDragedElementId}  isDragable={true} initialValues={dragInitialValues} onSelectSub={selectSub} form={form}/>}
           {(!neverSubFlag && !dropoutCheck) && (<Row>
            <Col span={24}>
              <Row gutter={6} className="sub-item-list-header">
                <Col span={5}>Drop Out</Col>
                <Col span={4}>Effective end date</Col>
                <Col span={5}>Reason Description</Col>
                <Col span={4}>Last Modified</Col>
                <Col>Actions</Col>
              </Row>
              <Form.List name="expandedDropOutItems">
                {(fields, { add, move, remove }, { errors }) => (
                  <>
                    {fields.map(({ key, name, ...resetField }) => (
                      <Row key={key} gutter={6} className="sub-item-list-item" >
                        <Col span={5} className="flex align-items-center">
                          <Row>
                            <Col className='flex align-items-center' style={{ paddingRight: '10.5px', justifyContent: 'center' }}>
                              <PlayCircleFilled rotate={90} style={{ fontSize: '16px', color: '#db6f6f' }} />
                            </Col>
                            <Col style={{ paddingTop: '4px' }}><span style={{ fontWeight: '600', color: '#194F72' }}>Drop Out</span></Col>
                          </Row>
                        </Col>
                        {/* <Col span={2}></Col> */}
                        <Col span={4}>
                          <Form.Item {...resetField} name={[name, 'endDate']}>
                            <DatePicker
                              disabledDate={disablePastDt}
                              onChange={(date, dateString) => handleItemChange(date, 'endDate', name, 'expandedDropOutItems')}
                              format={SLASH_DATE_FORMAT}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}><Form.Item
                          {...resetField}
                          name={[name, 'reasonDescription']}
                          rules={[{
                            required: (dropoutCheck !== null && dropoutCheck) ? false : true,
                            message: 'Please input Reason Code!'
                          }]}
                        >
                        <CustomLabel />
                        </Form.Item>
                          <Form.Item hidden={true}
                            {...resetField}
                            name={[name, 'reasonCode']}
                          ></Form.Item></Col>
                        <Col span={4}>
                          <Form.Item
                            className="createdByName font-size-14-bold"
                            name={[name, 'modifiedByName']}
                          >
                            <CustomLabel />
                          </Form.Item>
                          <div className="flex align-items-center series-tips-timestamp-items">
                            <Form.Item className="tips-content-item" name={[name, 'modifiedById']}>
                              <CustomLabel />
                            </Form.Item>
                            <Form.Item className="sub-item-position" name={[name, 'modifiedTimestamp']}>
                              <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col className='flex align-items-center'>
                          <Button onClick={() => handleRemoveItem(remove, name)} className={'no-border'}>
                            <FontAwesomeIcon icon={faTrash} color="#6b6b6c" style={{ height: "13px", width: "13px" }} />
                          </Button>
                        </Col>
                      </Row>
                    ))}
                    {fields.length < 1 &&
                      <Row>
                        <Col span={1} offset={23}>
                          <Form.Item>
                            <Button
                              className="subs-header-btn no-border"
                              icon={<PlusOutlined />}
                              onClick={() => handleAddDropout(add, 'dropout', fields, errors)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    }
                  </>
                )}
              </Form.List>
            </Col>
          </Row>)}
          {(!neverSubFlag && !dropoutCheck) && (
            <Row>
              <Col span={24}>
                <Row gutter={6} className="sub-item-list-header">
                  <Col span={3}>Not Suit Sub</Col>
                  <Col span={5}>Sub Item</Col>
                  {/*<Col span={1}></Col> cot-9714, align columns*/} 
                  <Col span={3}>Effective end date</Col>
                  <Col span={3}>Reason Code</Col>
                  {/* {title === 'Edit sub rule' && <Col span={5}>Created By</Col>} */}
                  <Col span={4}>Last Modified</Col>
                  <Col span={2}>Cust Approve</Col>
                  <Col>Actions</Col>
                </Row>
                <Form.List name="expandedNoSubItems">
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {fields.map(({ key, name, ...resetField }) => (
                        renderDraggableToNoSubsRow(key, name, fields, 'expandedNoSubItems', add, remove, resetField)
                      ))}
                      <Row>
                        <Col span={1} offset={23}>
                          <Form.Item>
                         
                                <Button
                                  className="subs-header-btn no-border"
                                  icon={<PlusOutlined />}
                                   onClick={() => handleOperatedSubItems(add, false, fields, errors)}
                                  title='Click + to add items to drag and drop'
                                />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>
          )}
       
          {/** these form item just store parent level timestamp value, will be hidden */}
          <Form.Item hidden name="createdByName">
            <CustomLabel />
          </Form.Item>
          <Form.Item hidden name="createdById">
            <CustomLabel />
          </Form.Item>
          <Form.Item hidden name="createTimestamp">
            <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
          </Form.Item>
          <Form.Item hidden name="modifiedByName">
            <CustomLabel />
          </Form.Item>
          <Form.Item hidden name="modifiedById">
            <CustomLabel />
          </Form.Item>
          <Form.Item hidden name="modifiedTimestamp">
            <CustomLabel dataType={DATE_TIME_ONE_FORMAT} />
          </Form.Item>
          {!footer && (
            <div className="subs-footer flex justify-end">
              {((title === "Edit sub rule" && (neverSubFlag || dropoutCheck)) || (title === "Add sub rule" && isExist && (neverSubFlag || dropoutCheck))) &&
                <Button onClick={onDeleteNeverSub} className="default-btn">
                  Delete
                </Button>
              }
              <Button id="cancelbutton" className="default-btn" onClick={onReset} style={{marginLeft:"2px"}}>
                {cancelText}
              </Button>
              <Button id="okbutton" onClick={onFinish} disabled={title === "Add sub rule" && isSaveBtnDisabled && !isExistDropOutRule} type="primary" className='primary-btn' style={{marginLeft:"2px"}}>
                {okText}
              </Button>
            </div>
          )}
        </Form>
      </Spin>
      </DndProvider>
      {isSelectSubModalVisible && renderSelectSubModal}
    </Modal>
    </>
  );
};
